export function formasDePago(state, getters, rootState) {
    
    // PAGO DIFERIDO es para pagarle a proveedores con cheque propio: en un cobro
    // asentaría contra una cuenta del pasivo. El cheque del cliente es CHEQUE.
    var formasDePago = JSON.parse(JSON.stringify(state.formas_de_pago))
        .filter(item => item.nombre !== "PAGO DIFERIDO")
    if (rootState.remitos.esPedidoYa) {
        var removeIndex = formasDePago.map(item => item.nombre).indexOf("TARJETA DE CRÉDITO");
        if (removeIndex > 0) {
            formasDePago.splice(removeIndex, 1);
        }
    } else {
        var removeIndex = formasDePago.map(item => item.nombre).indexOf("VOUCHER");
        if (removeIndex > 0) {

            formasDePago.splice(removeIndex, 1);
        }
    }
    return formasDePago

}




